import { cva, cx } from '@vizit/theme';
import { Row as AriaRow, type RowProps, composeRenderProps } from 'react-aria-components';

const rowClasses = cva({
  base: ['border-b border-secondary last:border-b-0'],
});

/**
 * A table row component that wraps React Aria's Row component with custom styling.
 *
 * @param props - The props for the Row component
 * @example
 * <Row>
 *   <Cell>Cell 1</Cell>
 *   <Cell>Cell 2</Cell>
 * </Row>
 */
function Row<T extends object>(props: RowProps<T> & { ref?: (element: HTMLTableRowElement) => void }) {
  const { className, ref, ...other } = props;

  return (
    <AriaRow
      ref={ref}
      className={composeRenderProps(className, (className) => cx(rowClasses(), className))}
      {...other}
    />
  );
}

export { Row };
export type { RowProps };
